import React, { useState, useEffect } from "react";
import {
  Layout,
  Menu,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Popconfirm,
  message,
  Row,
  Col,
  Statistic,
  Tag,
  Tabs,
  DatePicker,
  Upload,
  Switch,
  Divider,
  Badge,
  Typography,
  Drawer,
} from "antd";
import {
  ShoppingCartOutlined,
  AppstoreOutlined,
  TagsOutlined,
  GiftOutlined,
  DashboardOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  UploadOutlined,
  DollarOutlined,
  ShoppingOutlined,
  UserOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { dashboardService } from "../services";
import { useApiEnhanced } from "../hooks/useApiEnhanced";

const { Header, Sider, Content } = Layout;
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;
const { TabPane } = Tabs;

// Dashboard Reports Component
const DashboardReports = () => {
  const {
    data: stats,
    loading: statsLoading,
    error: statsError,
    execute: getStats,
  } = useApiEnhanced(
    (data) => dashboardService.getDashboardStats({ page: 1, size: 100 }),
    { immediate: true } // Load immediately
  );

  // const [stats] = useState({
  //   totalRevenue: 125430,
  //   totalOrders: 486,
  //   totalProducts: 124,
  //   totalCustomers: 1893,
  //   pendingOrders: 23,
  //   completedOrders: 463
  // });

  const {
    data: recentOrders,
    loading: ordersLoading,
    error: orderErorr,
    execute: getRecentOrder,
  } = useApiEnhanced(
    (data) => dashboardService.getRecentOrders({ page: 1, size: 100 }),
    { immediate: true } // Load immediately
  );

  // const recentOrders = [
  //   { id: 'ORD001', customer: 'John Doe', amount: 299, status: 'Pending', date: '2024-01-15' },
  //   { id: 'ORD002', customer: 'Jane Smith', amount: 599, status: 'Shipped', date: '2024-01-15' },
  //   { id: 'ORD003', customer: 'Bob Johnson', amount: 149, status: 'Delivered', date: '2024-01-14' },
  //   { id: 'ORD004', customer: 'Alice Brown', amount: 899, status: 'Processing', date: '2024-01-14' },
  // ];

  const columns = [
    {
      title: "Order ID",
      dataIndex: "_id",
      key: "_id",
      render: (order) => `ODR_${order}`,
    },
    {
      title: "Customer",
      dataIndex: "user",
      key: "user",
      render: (user) => `${user?.name}`,
    },
    {
      title: "Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (amount) => `$${amount}`,
    },
    {
      title: "Status",
      dataIndex: "orderStatus",
      key: "orderStatus",
      render: (status) => {
        const colors = {
          Pending: "orange",
          Processing: "blue",
          Shipped: "cyan",
          Delivered: "green",
        };
        return <Tag color={colors[status]}>{status}</Tag>;
      },
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => `${date?.split("T")[0]}`,
    },
  ];

  return (
    <div>
      <Title level={3}>Dashboard Overview</Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total Revenue"
              value={stats?.data?.totalRevenue}
              prefix={<DollarOutlined />}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total Orders"
              value={stats?.data?.totalOrders}
              prefix={<ShoppingCartOutlined />}
              valueStyle={{ color: "#1890ff" }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total Products"
              value={stats?.data?.totalProducts}
              prefix={<ShoppingOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total Customers"
              value={stats?.data?.totalCustomers}
              prefix={<UserOutlined />}
              valueStyle={{ color: "#722ed1" }}
            />
          </Card>
        </Col>
      </Row>
      {console.log(recentOrders, "recentOrders")}
      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={16}>
          <Card title="Recent Orders">
            <Table
              columns={columns}
              dataSource={recentOrders?.data}
              pagination={false}
            />
          </Card>
        </Col>
        <Col xs={24} lg={8}>
          <Card title="Order Status">
            <div style={{ marginBottom: 16 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 8,
                }}
              >
                <Text>Pending Orders</Text>
                <Badge
                  count={stats?.data?.pendingOrders}
                  style={{ backgroundColor: "#faad14" }}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Text>Completed Orders</Text>
                <Badge
                  count={stats?.data?.completedOrders}
                  style={{ backgroundColor: "#52c41a" }}
                />
              </div>
            </div>
            <Divider />
            {/* <div>
              <Text strong>Quick Stats</Text>
              <div style={{ marginTop: 12 }}>
                <Text type="secondary">Conversion Rate: 3.2%</Text><br />
                <Text type="secondary">Avg. Order Value: $258</Text><br />
                <Text type="secondary">Cart Abandonment: 68%</Text>
              </div>
            </div> */}
          </Card>
        </Col>
      </Row>
    </div>
  );
};
export default DashboardReports;
